module.exports = __webpack_public_path__ + "img/病虫害防治图片.a2176a24.svg";